import classes from "./css/PrivacyPolicy.module.css";

const PrivacyPolicy = () => {
  return (
    <div className={classes.main_privacy}>
      <div className={classes.info_privacy}>
        <span>Privacy </span>
        <span>Policy</span>
      </div>

      <div className={classes.content_privacy}>
        <h5>Chi Siamo</h5>
        <p>
          L’indirizzo del nostro sito web è: http://www.nicasioanzelmo.com Quali
          dati personali raccogliamo e perché li raccogliamo:
        </p>

        <h5>Modulo di contatto</h5>
        <p>
          I dati provenienti dal modulo di contatto che trovate all'interno del
          footer vengono utilizzati solo per rispondere all'utente
        </p>

        <h5>Cookie</h5>
        <p>
          Se hai un account e accedi a questo sito, verrà impostato un cookie
          temporaneo per determinare se il tuo browser accetta i cookie. Questo
          cookie non contiene dati personali e viene eliminato quando chiudi il
          browser. <br /><br /> Quando effettui l’accesso, verranno impostati diversi
          cookie per salvare le tue informazioni di accesso e le tue opzioni di
          visualizzazione dello schermo. I cookie di accesso durano due giorni
          mentre i cookie per le opzioni dello schermo durano un anno. Se
          selezioni “Ricordami”, il tuo accesso persisterà per due settimane. Se
          esci dal tuo account, i cookie di accesso verranno rimossi. <br /><br /> Gli
          articoli su questo sito possono includere contenuti incorporati (ad
          esempio video, immagini, articoli, ecc.). I contenuti incorporati da
          altri siti web si comportano esattamente allo stesso modo come se il
          visitatore avesse visitato l’altro sito web. <br /><br /> Questi siti web
          possono raccogliere dati su di te, usare cookie, integrare ulteriori
          tracciamenti di terze parti e monitorare l’interazione con quel
          contenuto incorporato, incluso il tracciamento della tua interazione
          con il contenuto incorporato se hai un account e hai effettuato
          l’accesso a quel sito web.
        </p>

        <h5>Chi Siamo</h5>
        <p>
          Per gli utenti che si registrano sul nostro sito web (se presenti),
          memorizziamo anche le informazioni personali che forniscono nel loro
          profilo utente. Tutti gli utenti possono vedere, modificare o
          cancellare le loro informazioni personali in qualsiasi momento
          (eccetto il loro nome utente che non possono cambiare). Gli
          amministratori del sito web possono anche vedere e modificare queste
          informazioni. <br /><br /> Quali diritti hai sui tuoi dati <br /><br />
          Se hai un account su questo sito, o hai lasciato commenti, puoi
          richiedere di ricevere un file esportato dal sito con i dati personali
          che abbiamo su di te, compresi i dati che ci hai fornito. Puoi anche
          richiedere che cancelliamo tutti i dati personali che ti riguardano.
          Questo non include i dati che siamo obbligati a conservare per scopi
          amministrativi, legali o di sicurezza. <br /><br />
          Per maggiori informazioni contattare l’indirizzo:
          info@nicasioanzelmo.com
        </p>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
